import { useMedplumProfile } from '@medplum/react-hooks';
import { LogOut, Menu, Moon, Sun } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useSidebar } from '../../../contexts/SidebarContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { medplum } from '../../../medplum';
import { patientDisplayName } from '../auth/patientRole';

/** Portal top bar: signed-in patient name, theme toggle, sign out. */
export function PortalHeader() {
  const { resolvedTheme, toggleTheme } = useTheme();
  const { toggleMobileOpen } = useSidebar();
  const profile = useMedplumProfile();
  const displayName = patientDisplayName(profile);

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card px-3 md:px-6">
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={toggleMobileOpen}
          aria-label="Open navigation"
          data-testid="portal-nav-toggle"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="text-sm font-medium text-muted-foreground" data-testid="portal-header-title">
          Patient <span className="font-semibold text-foreground">Portal</span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span className="hidden text-sm text-muted-foreground sm:inline" data-testid="portal-patient-name">
          {displayName}
        </span>
        <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Toggle theme" title="Toggle light/dark">
          {resolvedTheme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            void medplum.signOut();
          }}
          aria-label="Sign out"
          title="Sign out"
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
}
